module.exports = __webpack_public_path__ + "static/media/03.2ec4e729.png";